import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { skuit } from 'src/services/skuit'

import { SkuListTable } from 'src/components/Table/list/Sku'
import { ListPage } from 'src/components/Pages/ListPage'

export const SkuListPage = () => {
  const paginator = useQueryPaginator('sku-list', skuit.sc.skus.list)

  const exportFields = [
    "client_guid",
    "client_name",
    "guid",
    "is_active",
    "num_available",
    "num_awaiting_shipment",
    "num_damaged",
    "num_reserved",
    "num_units",
    "sku",
    "storage_health",
    "track_date_received",
  ]

  return (
    <ListPage
      title='SKUs'
      paginator={paginator}
    >
      <SkuListTable
        paginator={paginator}
        fields={['sku', 'client', 'productName', 'numAvailable', 'numReserved', 'numAwaitingShipment', 'isActive', 'health']}

        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.sc.skus.export,
        }}
      />
    </ListPage>
  )
}
